import React from "react";
// import NumberOfRoomBookedChart from "./room-report/NumberOfRoomBookedChart";
// import RevenueMonthlyChart from "./room-report/RevenueMonthlyChart";
import { useAuth } from "../../../auth/context/AuthProvider";
import { subYears, startOfMonth } from "date-fns";
import NumberOfRoomBookedHighcharts from "./room-report/NumberOfRoomBookedHighcharts";
import RevenueMonthlyHighcharts from "./room-report/RevenueMonthlyHighcharts";

const RoomReportContent: React.FC = () => {
    const { user } = useAuth();
    const startDate = startOfMonth(subYears(new Date(), 1));
    const endDate = startOfMonth(new Date());

    return (
        <div className="container-fluid mt-4">
            <div style={{ width: "100%", height: 800 }}>
                <div className="mt-4">
                    <h2>Number of Rooms Booked in Current Year</h2>
                    {/* <NumberOfRoomBookedChart propertyId={user?.active_property_id} startDate={startDate} endDate={endDate} /> */}
                    <NumberOfRoomBookedHighcharts propertyId={user?.active_property_id} startDate={startDate} endDate={endDate} />
                </div>

                <div className="mt-4">
                    <h2>Night Revenue in Current Year</h2>
                    {/* <RevenueMonthlyChart propertyId={user?.active_property_id} startDate={startDate} endDate={endDate} /> */}
                    <RevenueMonthlyHighcharts propertyId={user?.active_property_id} startDate={startDate} endDate={endDate} />
                </div>
            </div>
        </div>
    );
};

export default RoomReportContent;